import * as actions from '../utils/Constants';
import { apiRequest, apiGet, Methods } from '../utils/Api';
const api = `${process.env.REACT_APP_API_HOST}api/staticdata/`;


export const getAppVersion = () => {
    return {
        type: actions.GET_APP_VERSION,
        payload: apiGet(`${api}appversion`)
    }
}

export const getPersonnelTypes = () => {
    return {
        type: actions.GET_PERSONNEL_TYPES,
        payload: apiGet(`${api}personnelTypes`)
    }
}

export const getPersonTypes = () => {
    return {
        type: actions.GET_PERSONTYPES,
        payload: apiGet(`${api}personTypes`)
    }
}

export const getDisciplines = () => {
    return {
        type: actions.GET_DISCIPLINES,
        payload: apiGet(`${api}disciplines`)
    }
}

export const getAddressTypes = () => {
    return {
        type: actions.GET_ADDRESSTYPES,
        payload: apiGet(`${api}addressTypes`)
    }
}

export const getJournalTypes = () => {
    return {
        type: actions.GET_JOURNALTYPES,
        payload: apiGet(`${api}journalTypes`)
    }
}

export const getJournalStatusTypes = () => {
    return {
        type: actions.GET_JOURNAL_STATUS_TYPES,
        payload: apiGet(`${api}journalStatusTypes`)
    }
}

export const getClaims = () => {
    return {
        type: actions.GET_CLAIMS,
        payload: fetch(`${api}claims`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getCourtsList = () => {
    return {
        type: actions.GET_COURTSLIST,
        payload: fetch(`${api}courtslist`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getCourtTypes = () => {
    return {
        type: actions.GET_COURTTYPES,
        payload: fetch(`${api}courttypes`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getGenerations = () => {
    return {
        type: 'GET_GENERATIONS',
        payload: fetch(`${api}generations`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getPhoneTypes = () => {
    return {
        type: 'GET_PHONETYPES',
        payload: fetch(`${api}phonetypes`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getProperTitles = () => {
    return {
        type: 'GET_PROPERTITLES',
        payload: fetch(`${api}propertitles`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getStates = () => {
    return {
        type: 'GET_STATES',
        payload: fetch(`${api}states`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getTrainingLocationTypes = () => {
    return {
        type: 'GET_TRAINING_LOCATION_TYPES',
        payload: fetch(`${api}trainingLocationTypes`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getTimeZones = () => {
    return dispatch => dispatch({
        type: actions.GET_TIME_ZONES,
        payload: apiRequest(`${ api }timeZones`, Methods.get, null, dispatch) 
    });
}

export const getGrantTypes = () => {
    return {
        type: 'GET_GRANT_TYPES',
        payload: fetch(`${api}granttypes`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getRoles = () => {
    return {
        type: 'GET_ROLES',
        payload: fetch(`${api}roles`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getProgramDocumentTypes = () => {
    return {
        type: actions.GET_PROGRAMDOCUMENTTYPES,
        payload: fetch(`${api}programdocumenttypes`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getPersonDocumentTypes = () => {
    return {
        type: actions.GET_PERSONDOCUMENTTYPES,
        payload: fetch(`${api}persondocumenttypes`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getTrainingDocumentTypes = () => {
    return {
        type: actions.GET_TRAININGDOCUMENTTYPES,
        payload: apiGet(`${api}trainingdocumenttypes`)
    }
}

export const getCommitteeAssignments = () => {
    return {
        type: actions.GET_COMMITTEEASSIGNMENTS,
        payload: apiGet(`${api}committeeassignments`)
    }
}

export const getCounties = (stateId) => {
    return dispatch => dispatch({
        type: actions.GET_COUNTIES,
        payload: stateId ? apiRequest(`${api}state/${stateId}/counties`, Methods.get, null, dispatch) : []
    });
};

export const getCities = (countyId) => {
    return dispatch => dispatch({
        type: actions.GET_CITIES,
        payload: countyId ? apiRequest(`${api}county/${countyId}/cities`, Methods.get, null, dispatch) : []
    });
};